import { useCallback } from "react";
import styled from "styled-components";
import {
  CheckIcon,
  LockClosedIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { Button } from "@sablier/v2-components/molecules";
import { tags } from "@sablier/v2-constants";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useModalAutofillCreate } from "~/client/hooks";
import { useAutofillPrepare } from "../../logic";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    width: 100%;
    padding: calc(${(props) => props.theme.sizes.edge} * 1)
      ${(props) => props.theme.sizes.modalEdge};
    border-top: 2px solid ${(props) => props.theme.colors.border};
  }
`;

const Actions = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    margin-left: auto;
    column-gap: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    padding: calc(${(props) => props.theme.sizes.edge} * 1)
      calc(${(props) => props.theme.sizes.edge} * 3 / 2);
  }
  ${(props) => props.theme.medias.maxSM} {
    padding: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
  }
`;

export default function Footer() {
  const { t } = useT();
  const { data, doClose } = useModalAutofillCreate();
  const { isPrepared, warning } = useAutofillPrepare();

  const onConfirm = useCallback(() => {
    if (warning.state === "ready") {
      data.onConfirm(warning.value);
    }

    doClose();
  }, [data, doClose, warning]);

  return (
    <Wrapper>
      <Actions>
        <Button
          accent={"iconic400"}
          appearance={"outline"}
          right={XMarkIcon}
          onClick={doClose}
          title={t("words.cancel")}
        />
        <Button
          accent={"iconic400"}
          appearance={"outline"}
          isDisabled={!isPrepared}
          onClick={onConfirm}
          right={isPrepared ? CheckIcon : LockClosedIcon}
          title={t("structs.fillIn")}
          cy={tags.actionFillIn}
        />
      </Actions>
    </Wrapper>
  );
}
